import { v4 as uuidv4 } from 'uuid';
import { deepClone, isBlank } from "@/common/utils";

export const asset = {
  state: {
    assets: {

    },
    site_assets: {

    }
  },
  mutations: {
    insertAsset(state, newAsset) {
      state.assets[newAsset.uuid] = newAsset;
    },

    insertSiteAsset(state, args) {
      if (state.site_assets[args.siteUUID]) {
        state.site_assets[args.siteUUID].push(args.assetUUID);
      } else {
        state.site_assets[args.siteUUID] = [ args.assetUUID ];
      }
    },

    updateAsset(state, payload) {
      const asset_uuid = payload.uuid;
      //const asset = state[asset_uuid];
      if (state.assets[asset_uuid]) {
        state.assets[asset_uuid] = payload;
      }
    },

    removeAsset(state, asset_uuid) {
      const asset = state.assets[asset_uuid];
      if (asset) {
        const site_uuid = asset.site_uuid
        delete state.assets[asset_uuid];
        state.site_assets[site_uuid] = state.site_assets[site_uuid].filter(function(aUUID) {
          return aUUID !== asset_uuid;
        });
        if (isBlank(state.site_assets[site_uuid])) {
          delete state.site_assets[site_uuid]
        }
      }
    },

    removeSiteAssets(state, site_uuid) {
      const asset_uuids = state.site_assets[site_uuid];
      asset_uuids.forEach(function(asset_uuid) {
        delete state.assets[asset_uuid];
      });
      delete state.site_assets[site_uuid];
    },

    removeAllAssets(state) {
      state.assets = {};
      state.site_assets = {};
    }
  },
  actions: {
    addAsset({ commit }, payload) {
      console.log("Inside asset.mondule.js, addAsset(), payload ==> ", payload);
      let new_asset = payload;

      if (!new_asset.uuid) {
        new_asset.created_at = new Date().toISOString();
        new_asset.updated_at = new Date().toISOString();
        new_asset.uuid = uuidv4();  
      }

      commit("insertAsset", new_asset);
      commit("insertSiteAsset", { siteUUID: new_asset.site_uuid, assetUUID: new_asset.uuid });
      return new_asset.uuid;
    },

    modifyAsset({ commit }, payload) {
      const asset = deepClone(payload);
      asset.updated_at = new Date().toISOString();
      commit("updateAsset", asset);
    },

    timestampAssetSync({ commit, getters }, asset_uuid) {
      const asset = getters.getAssetByUUID(asset_uuid);
      asset.sync_on = new Date().toISOString();
      commit("updateAsset", asset);
    },

    nullifyAssetMeters({ commit, getters }, meter_uuid) {
      const all_assets = Object.values(getters.searchAssetsBy({ meter_uuid: meter_uuid }));
      all_assets.forEach(function(asset) {
        const editing_asset = getters.getAssetByUUID(asset.uuid)
        editing_asset.meter_uuid = null;
        commit("updateAsset", editing_asset);
      })
    },

    nullifyAssetLocations({ commit, getters }, location_uuid) {
      const all_assets = Object.values(getters.searchAssetsBy({ location_uuid: location_uuid }));
      all_assets.forEach(function(asset) {
        const editing_asset = getters.getAssetByUUID(asset.uuid)
        editing_asset.location_uuid = null;
        commit("updateAsset", editing_asset);
      })
    },

    deleteAsset({ commit, dispatch }, asset_uuid) {
      dispatch('deleteNotesByOwner', asset_uuid);
      dispatch('deleteImagesByOwner', asset_uuid);
      dispatch('deleteEmosByOwner', asset_uuid);
      commit("removeAsset", asset_uuid);
    },

    deleteAssetsBySite({ getters, dispatch }, site_uuid) {
      const assets = getters.getAssetsBySiteUUID(site_uuid);
      assets.forEach(function(asset) {
        dispatch('deleteAsset', asset.uuid);
      })
    },

    clearAllAssets({ commit }) {
      commit("removeAllAssets");
    }
  },
  getters: {
    allAssets(state) {
      return state.assets
    },

    allSiteAssets(state) {
      return state.site_assets
    },

    assetEmpty(_, getters) {
      return (Object.keys(getters.allAssets).length == 0)
    },

    getAssetByUUID(state) {
      return function(uuid) {
        const asset = state.assets[uuid];
        return asset ? deepClone(asset) : null;
      }
    },

    getAssetsBySiteUUID(state, getters) {
      return function(siteUUID) {
        const assetUUIDs = state.site_assets[siteUUID];
        if (assetUUIDs) {
          return assetUUIDs.map(function(assetUUID) {
            return getters.getAssetByUUID(assetUUID);
          });
        } else {
          return []
        }
      }
    },

    getAssetByName(state) {
      return function(giveName) {
        const asset = Object.values(state.assets).find(function(asset) {
          return (asset.name == giveName)
        });
        return asset ? deepClone(asset) : null;
      }
    },

    nbAssetsBySite() {
      return function(ownerUUID) {
        return this.getAssetsBySiteUUID(ownerUUID).length
      }
    },

    withAssetNameLike(state) {
      return function(name) {
        const patt = new RegExp(name + " \\d");
        const assets = Object.values(state.assets).filter(function(asset) {
          return patt.test(asset.name);
        });
        return assets.map(a => deepClone(a));
      }
    },

    nameForAsset() {
      return function(assetSubType) {
        const assets = this.withAssetNameLike(assetSubType.name);
        if (assets.length == 0) {
          return assetSubType.name + " 1";
        } else {
          const lastSeqNo = assets.reduce(function(largestSoFar, asset) {
            const seqNo = parseInt(asset.name.replace(/\D/g, ''));
            if (!isNaN(seqNo)) {
              if (seqNo > largestSoFar) {
                return seqNo
              } else {
                return largestSoFar
              }
            } else {
              return largestSoFar
            }
          }, 0);
          return assetSubType.name + " " + (lastSeqNo + 1).toString();
        }
      }

    },

    searchAssetsBy(_, getters) {
      return function(args) {
        let assets = (args.site_uuid) ? getters.getAssetsBySiteUUID(args.site_uuid) : Object.values(getters.allAssets);
        if (args.location_uuid) {
          assets = assets.filter(function(asset) {
            return asset.location_uuid == args.location_uuid;
          })
        }
        if (args.energy_source_uuid) {
          assets = assets.filter(function(asset) {
            return asset.energy_source_uuid == args.energy_source_uuid;
          })          
        }
        if (args.meter_uuid) {
          assets = assets.filter(function(asset) {
            return asset.meter_uuid == args.meter_uuid;
          })          
        }        
        console.log("Inside asset.module.js searchAssetsBy, assets ==> ", assets);
        return assets;        
      }
    }


  }
}